module.exports = __webpack_public_path__ + "img/17_11.f1c3c2c6.png";